module.exports = __webpack_public_path__ + "static/media/with-client.f827ab53.jpg";